import React from "react";

const ChevronRightRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 6.5L12 9.75L8.5 13",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(ChevronRightRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;